module.exports = __webpack_public_path__ + "static/fonts/Fact-Medium.95e241c.woff2";